<div class="card">
  <div class="card-body">
    {{ data.id }} - {{ data.name }}
    <div class="btn-group float-right">
      <a class="btn btn-secondary" routerLink="/customers/{{ data.id }}" translate>MORE_INFO</a>
      <lib-action-btn [item]="data" [config]="actionConfig"></lib-action-btn>
    </div>
  </div>
</div>
